export default function getEntryTypes() {
    const base = PerformanceObserver.supportedEntryTypes || [
        'event',
        'first-input',
        'largest-contentful-paint',
        'layout-shift',
        'longtask',
        'navigation',
        'paint',
        'resource',
    ];

    return base;
}
